import { useSelector, useDispatch } from 'react-redux'
import { isEqual, isArray } from 'underscore'
import { itemsFetchData } from '../../redux/items'
import {
  parseSubjectsFromUrl,
  removeCountryFromSubjects,
  removeYearFromSubjects
} from '../../SearchUtils'

function SearchLabel({ searchLabel }) {
  const currentFilters = useSelector((state) => state.items.currentFilters)

  const dispatch = useDispatch()
  const fetchData = (filters, options) =>
    dispatch(itemsFetchData({ filters, options }))

  const removeFilter = () => {
    const newFilters = { ...currentFilters }
    const options = {}

    if (isArray(currentFilters[searchLabel.field])) {
      if (currentFilters[searchLabel.field].length === 1) {
        delete newFilters[searchLabel.field]
      } else {
        newFilters[searchLabel.field] = currentFilters[
          searchLabel.field
        ].filter((val) => val !== searchLabel.value)
      }
    } else {
      delete newFilters[searchLabel.field]
    }

    const currentSubjects = parseSubjectsFromUrl()

    if (searchLabel.subjects && window.location.pathname !== '/cars') {
      if (isEqual(currentSubjects, searchLabel.subjects)) {
        newFilters.subjects = []
      }

      if (currentSubjects.length === 3 && !currentSubjects.includes('in')) {
        newFilters.year = { from: currentSubjects[2], to: currentSubjects[2] }
      }

      if (currentSubjects.includes('in') && searchLabel.field !== 'country') {
        if (currentSubjects.length === 5) {
          newFilters.subjects = currentSubjects.slice(3)

          newFilters.year = { from: currentSubjects[2], to: currentSubjects[2] }
        } else if (currentSubjects.length === 3 && searchLabel.field === 'city') {
          newFilters.subjects = removeCountryFromSubjects(currentSubjects)
        } else if (currentSubjects.length > 2) {
          newFilters.subjects = currentSubjects.splice(-2)
        } else {
          newFilters.subjects = currentSubjects
        }
      }

      if (searchLabel.field === 'country' && !currentSubjects.includes('in')) {
        newFilters.subjects = currentSubjects
      }

      if (searchLabel.field === 'country' && currentSubjects.includes('in')) {
        newFilters.subjects = removeCountryFromSubjects(currentSubjects)
      }
    } else if (searchLabel.field === 'year') {
      newFilters.subjects = removeYearFromSubjects(currentSubjects)
    } else if (searchLabel.field === 'country') {
      newFilters.subjects = removeCountryFromSubjects(currentSubjects)
    } else {
      newFilters.subjects = currentSubjects
    }

    newFilters.popstate = 0

    fetchData(newFilters, options)
  }

  return (
    <button
      type="button"
      className="btn btn-sm btn-secondary py-1 my-1 me-1 rounded-8"
      style={{ backgroundColor: '#EDE9E5' }}
      title={searchLabel.title}
    >
      {searchLabel.label}
      <i className="fas fa-times ms-2" onClick={removeFilter} />
    </button>
  )
}

export default SearchLabel
